import { Icon } from '@opengov/component-library/dist';
import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';

import styles from './ReportAccessPanel.scss';

export const GranteeCellRenderer = (props: ICellRendererParams) => {
  return (
    <div className={styles.granteeCellWrapper}>
      {props.value} {props.data.granteeType === 'group' && <Icon icon={'object-group'} className={styles.iconGroup} />}
    </div>
  );
};

export const granteeCellRendererSelector = (params) => {
  return {
    component: 'GranteeCellRenderer',
    params
  };
};
